module.exports = __webpack_public_path__ + "static/media/39_tn.2ec7fca5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/39_tn.jpg
// module id = 675
// module chunks = 0